import { createAction, props } from '@ngrx/store';
import { ReviewerInteraction } from '@sleipai/sleip-models';

export const loadReviewerInteractions = createAction(
  '[ReviewerInteraction] Load ReviewerInteractions'
);

export const loadReviewInteractionById = createAction(
  '[ReviewerInteraction] Load ReviewerInteractions By Id',
  props<{ id: string, uid: string }>()
);

export const addSingleReviewInteraction = createAction(
  '[ReviewerInteraction] Add single review action',
  props<{ reviewActions: ReviewerInteraction }>()
);

export const updateSingleReviewInteraction = createAction(
  '[ReviewerInteraction] Update single review action',
  props<{ update: ReviewerInteraction }>()
)


